import styled from "styled-components";

export const Container = styled.div`
	flex: 3;
	max-width: 300px;
`;
